interface FlowchartTreeProps {
  folders: string[];
  selectedFolder: string;
  onSelectFolder: (folder: string) => void;
}

export default function FlowchartTree({ folders, selectedFolder, onSelectFolder }: FlowchartTreeProps) {
  return (
    <div style={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      MozUserSelect: 'none',
      msUserSelect: 'none'
    }}>
      <div style={{
        fontWeight: 600,
        fontSize: '14px',
        padding: '12px 16px',
        borderBottom: '1px solid var(--border)',
        color: 'var(--text-primary)',
        margin: 0
      }}>Folders</div>
      
      <div style={{
        flex: 1,
        overflowY: 'auto',
        padding: '8px 0',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
      }}>
        <div
          role="button"
          tabIndex={0}
          onClick={() => onSelectFolder('/')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onSelectFolder('/');
            }
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '6px 16px',
            cursor: 'pointer',
            fontSize: '14px',
            color: 'var(--text-primary)',
            transition: 'background-color 0.15s',
            background: 'transparent',
            border: 'none',
            width: '100%',
            textAlign: 'left',
            fontWeight: 500,
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            WebkitTapHighlightColor: 'transparent',
            ...(selectedFolder === '/' ? {
              backgroundColor: 'var(--accent-alpha-10)',
              borderLeft: '2px solid var(--accent)',
              paddingLeft: '14px',
              fontWeight: 600
            } : {})
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--bg-tertiary)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = selectedFolder === '/' ? 'var(--accent-alpha-10)' : 'transparent';
          }}
        >
          All Flowcharts
        </div>
        
        {folders.filter((f) => f !== '/').map((folder) => (
          <div
            key={folder}
            role="button"
            tabIndex={0}
            onClick={() => onSelectFolder(folder)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onSelectFolder(folder);
              }
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '6px 16px',
              cursor: 'pointer',
              fontSize: '14px',
              color: 'var(--text-primary)',
              transition: 'background-color 0.15s',
              background: 'transparent',
              border: 'none',
              width: '100%',
              textAlign: 'left',
              fontWeight: 500,
              userSelect: 'none',
              WebkitUserSelect: 'none',
              MozUserSelect: 'none',
              msUserSelect: 'none',
              WebkitTapHighlightColor: 'transparent',
              ...(selectedFolder === folder ? {
                backgroundColor: 'var(--accent-alpha-10)',
                borderLeft: '2px solid var(--accent)',
                paddingLeft: '14px',
                fontWeight: 600
              } : {})
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--bg-tertiary)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = selectedFolder === folder ? 'var(--accent-alpha-10)' : 'transparent';
            }}
          >
            {folder}
          </div>
        ))}
      </div>
    </div>
  );
}
